import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder,FormControl,FormGroup,Validators,} from '@angular/forms';
import { Router } from '@angular/router';
import { faCalendar, faPlus } from '@fortawesome/free-solid-svg-icons';
import { RegExpPatterns } from 'src/app/share/enums/regex-pattern.enum';
import { StorageKeys } from 'src/app/share/enums/storage.enum';
import { CompanyServiceService } from 'src/app/share/services/company-service/company-service.service';

import { MasterMakeService } from 'src/app/share/services/master-make/master-make.service';
import { StockService } from 'src/app/share/services/stock/stock.service';
import { StorageService } from 'src/app/share/services/storage-service/storage.service';
import { MessageService } from 'src/app/share/sharedsubject';
import { NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { PaymentAccountsService } from 'src/app/share/services/payment-account/payment-accounts.service';

@Component({
    selector: 'app-service-entry',
    templateUrl: './service-entry.component.html',
    styleUrls: ['./service-entry.component.scss'],
    standalone: false
})
export class ServiceEntryComponent implements OnInit {
  protected faCalendar = faCalendar;
  protected readonly faPlus = faPlus;
  private offcanvasRef: any = null;
  errorMessage: string;
  addServiceForm!: FormGroup;
  companyData: any[];
  dealerName: string = '';
  isLoading = false;
  selectDealer: string = '';
  userDetails: any;
  endOfResults: boolean = false;
  currentPageNumber: number = 0;
  pageNumber: number = 0;
  paymentMode: string = '';
  paymentType: string = '';
  showFullPaymentOption = true;
  showSplitPaymentOption = false;
  totalPriceWithSwpCharges: any;
  showReferenceName = false;
  showSwpCharges = false;
  swpCharges: number = 0;
  phoneList: any[] = [];
  phoneObj: any={page:0};
  phoneSearch: any;
  selectedPhoneNumber:any;
  checkSplitCount: boolean = true;
  hasTax: boolean = true;
  metaDataList: any;
  selectedServices: { [key: string]: boolean } = {};
  paymentTypes = [
    { value: 'Full', label: 'Full' },
    { value: 'Split', label: 'Split' }
  ];
  paymentModes = [
    { value: 'Cash', label: 'Cash' },
    { value: 'BankTransfer', label: 'Bank Transfer' },
    { value: 'UPI', label: 'UPI' },
    { value: 'Card', label: 'Card (Charges will be applied)' },
    { value: 'BajajFinance', label: 'Bajaj Finance' },
    { value: 'Credit', label: 'Credit' }
  ];
  leadList = [
    { value: 'WalkIn', label: 'Walk-in' },
    { value: 'TyreBuzzar', label: 'Tyre Buzzar' },
    { value: 'Google', label: 'Google' },
    { value: 'JustDial', label: 'Just Dial' },
    { value: 'Reference', label: 'Reference' }
  ];

  @ViewChild('accountFormModal') accountFormModal!: TemplateRef<any>;
  preSelectedBranch: string = '';
  preSelectedMode: string = '';

  accountState: { [key: string]: { list: any[], page: number, loading: boolean, isLastPage: boolean } } = {
    Full: { list: [], page: 0, loading: false, isLastPage: false },
    Cash: { list: [], page: 0, loading: false, isLastPage: false },
    BankTransfer: { list: [], page: 0, loading: false, isLastPage: false },
    UPI: { list: [], page: 0, loading: false, isLastPage: false },
    Card: { list: [], page: 0, loading: false, isLastPage: false },
    BajajFinance: { list: [], page: 0, loading: false, isLastPage: false }
  };

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly companyService: CompanyServiceService,
    private readonly stockService: StockService,
    private readonly masterMakeService: MasterMakeService,
    private readonly router: Router,
    private readonly storageService: StorageService,
    private readonly messageService: MessageService,
    private readonly offcanvasService: NgbOffcanvas,
    private readonly paymentAccountsService: PaymentAccountsService
  ) {
    this.addServiceForm = this.formBuilder.group({
      branch: this.userDetails?.enrollmentType === 'Company' ? ['', Validators.required]: [null],
      discount: [null],
      serviceTotal: [null],
      swpCharges: [null],
      totalAmount: [null, [Validators.required]],
      paymentType: ['Full', [Validators.required]],
      paymentMode: ['UPI', [Validators.required]],
      hasTax: [true],
      invoices: [null],
      customerName: ['', [Validators.required]],
      emailAddress: [
        undefined,
        Validators.pattern(RegExpPatterns.EmailPattern),
      ],
      phoneNumber: [
        '',
        [Validators.pattern(RegExpPatterns.MobilePattern), Validators.required],
      ],
      address: this.formBuilder.group({
        locality: [''],
      }),
      totalPriceWithCharge: [''],
      cashAmount: [null],
      bankTransferAmount: [null],
      upiAmount: [null],
      cardAmount: [null],
      bajajFinanceAmount: [null],
      paymentAccount: [null],
      cashAccount: [null],
      bankTransferAccount: [null],
      upiAccount: [null],
      cardAccount: [null],
      bajajFinanceAccount: [null],
      lead: [null],
      averageRunPerDay: [''],
      reference: ['',[Validators.pattern(RegExpPatterns.MobilePattern)]],
    });
  }

  ngOnInit(): void {
    this.userDetails = this.storageService.getDataFromLocalStorage(
      StorageKeys.SELF_DETAILS
    );
    if(this.userDetails?.enrollmentType === 'Company'){
      this.getAllCompanyList();
      this.addServiceForm.get('branch')?.setValidators([Validators.required]);
      this.addServiceForm.get('branch')?.setValue('', { emitEvent: false });
    } else {
      this.addServiceForm.get('branch')?.setValue(this.userDetails?.company);
      this.onBranchChange();
    }
    this.getMetaDataDetails();
  }

  onInput(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    if (inputElement.value.length > 10) {
      inputElement.value = inputElement.value.slice(0, 10);
      this.addServiceForm.controls['phoneNumber'].setValue(inputElement.value);
    }
  }

  onBranchChange() {
    const val = this.addServiceForm.get('branch')?.value;
    this.resetAllAccounts();
    if (val) {
      if (this.addServiceForm.get('paymentType')?.value === 'Full') {
        const pm = this.addServiceForm.get('paymentMode')?.value;
        if (pm && pm !== 'Credit') this.fetchAccounts('Full');
      } else {
        this.fetchAccounts('Cash');
        this.fetchAccounts('BankTransfer');
        this.fetchAccounts('UPI');
        this.fetchAccounts('Card');
        this.fetchAccounts('BajajFinance');
      }
    }
  }

  resetAllAccounts() {
    Object.keys(this.accountState).forEach(key => this.resetAccounts(key));
  }

  resetAccounts(type: string) {
    this.accountState[type] = { list: [], page: 0, loading: false, isLastPage: false };
    switch(type) {
      case 'Full': this.addServiceForm.get('paymentAccount')?.setValue(null); break;
      case 'Cash': this.addServiceForm.get('cashAccount')?.setValue(null); break;
      case 'BankTransfer': this.addServiceForm.get('bankTransferAccount')?.setValue(null); break;
      case 'UPI': this.addServiceForm.get('upiAccount')?.setValue(null); break;
      case 'Card': this.addServiceForm.get('cardAccount')?.setValue(null); break;
      case 'BajajFinance': this.addServiceForm.get('bajajFinanceAccount')?.setValue(null); break;
    }
  }

  fetchAccounts(type: string, isScroll: boolean = false) {
    const company = this.addServiceForm.get('branch')?.value;
    if (!company) return;

    let actualType = type === 'Full' ? this.addServiceForm.get('paymentMode')?.value : type;
    if (!actualType || actualType === 'Credit') return;

    if (isScroll) {
      this.accountState[type].page++;
    } else {
      this.accountState[type].page = 0;
      this.accountState[type].isLastPage = false;
      this.accountState[type].list = [];
    }

    if (this.accountState[type].loading || this.accountState[type].isLastPage) return;

    this.accountState[type].loading = true;

    this.paymentAccountsService.getCompanyPaymentAccount({ 
      company: company, paymentType: actualType, 
      page: this.accountState[type].page,
      status: true, sort: '_id', sortDir: 1
    }).subscribe({
      next: (res: any) => {
        this.accountState[type].loading = false;
        if (res.data && res.data.length > 0) {
          this.accountState[type].list = [...this.accountState[type].list, ...res.data];
          this.selectDefaultAccount(res.data, type);
        } else {
          this.accountState[type].isLastPage = true;
        }
      },
      error: () => {
        this.accountState[type].loading = false;
      }
    });
  }

  private selectDefaultAccount(resData: any[], type: string) {
    if (this.accountState[type].page !== 0) return;
    const defaultAcc = resData.find((a: any) => a.default);
    if (!defaultAcc) return;

    if (type === 'Full') {
      this.addServiceForm.get('paymentAccount')?.setValue(defaultAcc._id);
      return;
    }

    const prefix = this.getControlPrefix(type);
    if (prefix) {
      const amount = this.addServiceForm.get(`${prefix}Amount`)?.value;
      if (amount > 0) {
        this.addServiceForm.get(`${prefix}Account`)?.setValue(defaultAcc._id);
      }
    }
  }

  onAccountScroll(type: string) {
    this.fetchAccounts(type, true);
  }

  getControlPrefix(type: string): string {
    switch(type) {
      case 'Cash': return 'cash';
      case 'BankTransfer': return 'bankTransfer';
      case 'UPI': return 'upi';
      case 'Card': return 'card';
      case 'BajajFinance': return 'bajajFinance';
      default: return '';
    }
  }

  getAllCompanyList() {
    this.companyService.getToCompanyList().subscribe((res: any) => {
      this.companyData = (res.data || []).filter((company: any) => company.status === 'Active');
    });
  }

  hasAtLeastOneServiceSelected(): boolean {
    return Object.keys(this.selectedServices).some(id => this.selectedServices[id] && Number(this.addServiceForm.get(id)?.value) >= 1);
  }

  saveProduct() {
    if (!this.hasAtLeastOneServiceSelected()) {
      this.errorMessage = 'Please select at least one service.';
      return;
    }
    if (!this.validateSplitAmount() || this.isLoading) return;
    this.isLoading = true;
    let payload: any = { }
    payload = this.generatePayload();
    this.stockService.saveServiceDetails(payload).subscribe({
      next: (res:any) => {
      setTimeout(() => {
        this.messageService.sendMessage(res.message);
      }) 
      this.router.navigate(['/order-list'])
    },
      error: (error) => {
      this.isLoading = false;
      this.errorMessage = error?.error?.error?.message;
    }
    })
  }

  validateSplitAmount(): boolean {
    const paymentType = this.addServiceForm.get('paymentType')?.value;
    if (paymentType === 'Split') {
      const totalAmount = this.addServiceForm.get('totalAmount')?.value || 0;
      const splitAmt =
        (this.addServiceForm.get('upiAmount')?.value || 0) +
        (this.addServiceForm.get('bankTransferAmount')?.value || 0) +
        (this.addServiceForm.get('cashAmount')?.value || 0) +
        (this.addServiceForm.get('cardAmount')?.value || 0) +
        (this.addServiceForm.get('bajajFinanceAmount')?.value || 0);
      if (splitAmt !== totalAmount) {
        this.errorMessage = `Split amount total (₹${splitAmt}) does not match the order total (₹${totalAmount}). Please adjust the split amounts.`;
        return false;
      }
    }
    return true;
  }


  generatePayload() {
    let payload: any = {};
    if (!this.addServiceForm.value) return {}
    let formValues = { ...this.addServiceForm.value }
    payload = {
      company: formValues.branch,
      service: this.getServiceDetails(),
      paymentAccounts: this.getPaymentAccountsPayload(),
      phoneNumber: formValues.phoneNumber,
      customerName: formValues.customerName,
      emailAddress: formValues.emailAddress,
      lead: formValues.lead,
      averageRunPerDay: formValues.averageRunPerDay,
      address: formValues.address,
      discount: formValues.discount,
      hasTax: true,
      paymentType: formValues.paymentType,
      reference: formValues.reference,
      swpCharges: formValues.swpCharges,
      totalAmount: formValues.totalAmount,
    }
    if (formValues.paymentType === 'Full' && formValues.paymentMode === 'Credit') {
      payload.paymentMode = 'Credit'
    }
    return payload
  }

  showPayDetailsForm(paymentType: any) {
    if (paymentType == 'Full') {
      this.showFullPaymentOption = true;
      this.showSplitPaymentOption = false;
      this.addServiceForm.get('upiAmount')?.setValue(null);
      this.addServiceForm.get('bankTransferAmount')?.setValue(null);
      this.addServiceForm.get('cashAmount')?.setValue(null);
      this.addServiceForm.get('cardAmount')?.setValue(null);
      this.addServiceForm.get('bajajFinanceAmount')?.setValue(null);
      this.checkSplitCount= true;
      this.addServiceForm.get('paymentMode')?.setValue('UPI');
      this.addServiceForm.get('paymentMode')?.setValidators(Validators.required);
      this.addServiceForm.get('paymentMode')?.updateValueAndValidity();
      
      this.resetAccounts('Full');
      this.fetchAccounts('Full');
    } else {
      this.showFullPaymentOption = false;
      this.showSplitPaymentOption = true;
      this.addServiceForm.get('paymentMode')?.setValue(null);
      this.addServiceForm.get('paymentMode')?.clearValidators();
      this.addServiceForm.get('paymentMode')?.updateValueAndValidity();
      this.addServiceForm.get('swpCharges')?.setValue(null);
      this.checkSplitCount= false;
      this.resetAllAccounts();
      this.fetchAccounts('Cash');
      this.fetchAccounts('BankTransfer');
      this.fetchAccounts('UPI');
      this.fetchAccounts('Card');
      this.fetchAccounts('BajajFinance');
    }
    this.addServiceForm.get('swpCharges')?.setValue(null);
    this.calculateTotalService();
  }

  onPaymentModeChange(event: any): void {
    this.paymentMode = event;
    if (this.addServiceForm.get('paymentType')?.value === 'Full') {
      this.resetAccounts('Full');
      if (this.paymentMode && this.paymentMode !== 'Credit') {
        this.fetchAccounts('Full');
      }
    }
    this.calculateTotalService();
  }

  checkLeadType(leadType: any) {
    if (leadType == 'Reference') {
      this.showReferenceName = true;
    } else {
      this.showReferenceName = false;
      this.addServiceForm.get('leadRefrenceName')?.setValue('');
    }
  }

  splitAmountSum() {
    const payType = this.addServiceForm.get('paymentType')?.value;
    const upiAmount = this.addServiceForm.get('upiAmount')?.value;
    const bankTransferAmount = this.addServiceForm.get('bankTransferAmount')?.value;
    const cashAmount = this.addServiceForm.get('cashAmount')?.value;
    const cardAmount = this.addServiceForm.get('cardAmount')?.value;
    const bajajFinanceAmount = this.addServiceForm.get('bajajFinanceAmount')?.value;
    let count = 0;
    if (upiAmount) {
      count++;
    }
    if (bankTransferAmount) {
      count++;
    }
    if (cashAmount) {
      count++;
    }
    if (cardAmount) {
      count++;
    }
    if (bajajFinanceAmount) {
      count++;
    }
    if (payType =="Split" && count >= 2) {
      this.checkSplitCount = true;
    } else {
      this.checkSplitCount = false;
    }

    
    const splitTypes = ['Cash', 'BankTransfer', 'UPI', 'Card', 'BajajFinance'];
    splitTypes.forEach(type => {
      const prefix = this.getControlPrefix(type);
      const amountControl = this.addServiceForm.get(`${prefix}Amount`);
      const accountControl = this.addServiceForm.get(`${prefix}Account`);
      
      if (amountControl && accountControl) {
        if (amountControl.value > 0) {
          if (!accountControl.value) {
            const defaultAcc = this.accountState[type].list.find((a: any) => a.default);
            if (defaultAcc) {
              accountControl.setValue(defaultAcc._id);
            }
          }
        } else {
          accountControl.setValue(null);
        }
      }
    });

    const cardAmt = this.addServiceForm.get('cardAmount')?.value;
    if (!cardAmt || Number(cardAmt) <= 0) {
      this.addServiceForm.get('swpCharges')?.setValue(null);
    }
    this.calculateTotalService();
  }

  calculateTotalService() {
    this.showSwpCharges = false;
    let totalSalesAmt = 0;

    (this.metaDataList || []).forEach((metaDataItem: any) => {
      if (this.selectedServices[metaDataItem._id]) {
        let formValue = Number(this.addServiceForm.get(metaDataItem._id)?.value || 0);
        if (formValue) {
          totalSalesAmt += formValue;
        }
      }
    });

    if (totalSalesAmt === 0) {
      this.addServiceForm.get('totalAmount')?.setValue(null);
      return;
    }

    if(!this.hasTax){
      totalSalesAmt = Math.ceil(totalSalesAmt * 1.18);
    }
    let totalAmt =  totalSalesAmt;
    let discount = Math.ceil((this.addServiceForm.get('discount')?.value || 0));
    const discountControl = this.addServiceForm.get('discount');

    if (discount > 0 && discount >= totalAmt) {
      discountControl?.setErrors({ discountExceeded: true });
    } else {
      if (discountControl?.hasError('discountExceeded')) {
        discountControl.setErrors(null);
      }
      totalAmt = totalAmt - discount;
    }
    const payMode = this.addServiceForm.get('paymentMode')?.value;
    const payType = this.addServiceForm.get('paymentType')?.value;
    const cardAmt = Number(this.addServiceForm.get('cardAmount')?.value || 0);

    this.swpCharges = this.getCalculatedSwpCharges(totalAmt, payType, payMode, cardAmt);
    totalAmt = totalAmt  + this.swpCharges;
    this.addServiceForm.get('totalAmount')?.setValue(totalAmt > 0 ? totalAmt : null);
  }

  private getCalculatedSwpCharges(totalAmt: number, payType: string, payMode: string, cardAmt: number): number {
    if (payType === "Full" && payMode === "Card") {
      this.showSwpCharges = true;
      let swpChargePer = this.addServiceForm.get('swpCharges')?.value || 0;
      if (swpChargePer > 0 && swpChargePer < 100) {
        return Math.ceil(((swpChargePer / 100) * totalAmt));
      } else {
        this.addServiceForm.get('swpCharges')?.setValue(null);
        return 0;
      }
    } else if (payType === "Split" && cardAmt > 0) {
      this.showSwpCharges = false;
      let swpChargePer = this.addServiceForm.get('swpCharges')?.value || 0;
      if (swpChargePer > 0 && swpChargePer < 100) {
        return Math.ceil(((swpChargePer / 100) * cardAmt));
      } else {
        this.addServiceForm.get('swpCharges')?.setValue(null);
        return 0;
      }
    } else {
      this.addServiceForm.get('swpCharges')?.setValue(null);
      return 0;
    }
  }

  onOptionPhoneSelected(phoneNumber:any){
    let existingCustomer: any = (this.phoneList || []).filter(cust => cust.phoneNumber === phoneNumber.toString());
    if (existingCustomer?.[0]) {
      this.addServiceForm.controls['customerName'].setValue((existingCustomer || [])[0]?.customerName);
      this.addServiceForm.controls['emailAddress'].setValue((existingCustomer || [])[0]?.emailAddress);
      this.addServiceForm.controls['lead'].setValue((existingCustomer || [])[0]?.lead);
      this.addServiceForm.get('address.locality')?.patchValue((existingCustomer || [0])[0]?.address.locality);
    }
  }

  getUserIdsFirstWay($event: any) {
    this.stockService.getPhoneDetails({phoneNumber: $event.target.value}).subscribe((res:any) => {
      this.phoneList = res.data || [];
    })
  }

  onInputNumber(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    if (inputElement.value.length > 10) {
      inputElement.value = inputElement.value.slice(0, 10);
      this.addServiceForm.controls['reference'].setValue(inputElement.value);
    }
  }

  getMetaDataDetails() {
    this.masterMakeService.getActiveMetaDataDetails().subscribe({
      next: (res: any) => {
        this.metaDataList = res.data;
        this.generateMetaForm(this.metaDataList);
      },
      error: (error) => {
        this.errorMessage = error?.error?.error?.message;
      }
    });
  }

  generateMetaForm(metaData: any = []): void {
    metaData.forEach((data: any) => {
      this.selectedServices[data._id] = false;
      this.addServiceForm.addControl(data._id, new FormControl(null));
    });
  }

  toggleService(field: any, event?: any) {
    if (event) {
      event.stopPropagation();
    }
    const currentState = !!this.selectedServices[field._id];
    const newState = !currentState;
    this.selectedServices[field._id] = newState;
    const control = this.addServiceForm.get(field._id);

    if (newState) {
      control?.setValidators([Validators.required, Validators.min(1)]);
      const defaultAmt = Number(field.amount || 0);
      if (defaultAmt > 0) {
        control?.setValue(defaultAmt);
      } else {
        control?.setValue(null);
      }
    } else {
      control?.setValue(null);
      control?.clearValidators();
    }
    control?.markAsTouched();
    control?.updateValueAndValidity();
    this.calculateTotalService();
  }

  onAmountInput(field: any) {
    const control = this.addServiceForm.get(field._id);
    const val = control?.value;

    if (!this.selectedServices[field._id] && val !== null && val !== undefined && val !== '') {
      this.selectedServices[field._id] = true;
      control?.setValidators([Validators.required, Validators.min(1)]);
      control?.updateValueAndValidity();
    }
    this.calculateTotalService();
  }

  getServiceDetails() {
    let serviceData: any = [];
    this.metaDataList.forEach((metaDataItem: any) => {
      let formValue = this.addServiceForm.value[metaDataItem._id];
      if (formValue !== null && formValue !== undefined && formValue !== '') {
        serviceData.push({
          lookupId: metaDataItem._id,
          label: metaDataItem.label,
          value: formValue
        });
      }
    });
    return serviceData
  }

  getPaymentAccountsPayload(): any[] {
    const paymentType = this.addServiceForm.get('paymentType')?.value;
    let accounts: any[] = [];
    
    if (paymentType === 'Full') {
      const paymentMode = this.addServiceForm.get('paymentMode')?.value;
      if (paymentMode && paymentMode !== 'Credit') {
        let acc = this.addServiceForm.get('paymentAccount')?.value;
        if (!acc) {
          const defaultAcc = this.accountState['Full'].list.find((a: any) => a.default);
          if (defaultAcc) acc = defaultAcc._id;
        }
        if (acc) accounts.push({ paymentId: acc, amount: this.addServiceForm.get('totalAmount')?.value, mode: paymentMode });
      }
    } else if (paymentType === 'Split') {
      const splitTypes = ['Cash', 'BankTransfer', 'UPI', 'Card', 'BajajFinance'];
      splitTypes.forEach(type => {
        const prefix = this.getControlPrefix(type);
        const amountControl = this.addServiceForm.get(`${prefix}Amount`);
        if (amountControl && amountControl.value > 0) {
          let acc = this.addServiceForm.get(`${prefix}Account`)?.value;
          if (!acc) {
            const defaultAcc = this.accountState[type].list.find((a: any) => a.default);
            if (defaultAcc) acc = defaultAcc._id;
          }
          if (acc) accounts.push({ paymentId: acc, amount: amountControl.value, mode: type });
        }
      });
    }
    return accounts;
  }

  addNewPaymentAccount(paymentMode?: string) {
    this.preSelectedBranch = this.addServiceForm.get('branch')?.value || '';
    this.preSelectedMode = paymentMode || '';
    this.offcanvasRef = this.offcanvasService.open(this.accountFormModal, {
      position: 'end',
      panelClass: 'payment-account-detail-offcanvas',
      backdrop: 'static',
      keyboard: false
    });
  }

  onAccountSave(data: any) {
    this.offcanvasRef?.close();
    const savedMode = data.paymentType;
    if (this.addServiceForm.get('paymentType')?.value === 'Full') {
      this.resetAccounts('Full');
      this.fetchAccounts('Full');
    } else {
      this.resetAccounts(savedMode);
      this.fetchAccounts(savedMode);
    }
  }
}
